module.exports = __webpack_public_path__ + "static/media/jianchu.3715a2b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageUrlSec/jianchu.svg
// module id = 576
// module chunks = 0